import React, { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFaceSmile } from '@fortawesome/pro-regular-svg-icons';
import Picker, { IEmojiData, SKIN_TONE_LIGHT } from 'emoji-picker-react';
import { Dropdown, DropdownContent, DropdownTrigger } from 'components/UI/V3/Dropdown';
import styles from './EmojiPickerButton.module.scss';

interface EmojiPickerButtonProps {
    // eslint-disable-next-line no-unused-vars
    onSelect: (emoji: string) => void;
    className?: string;
    ariaLabel?: string;
    align?: 'start' | 'center' | 'end';
}

// Same picker as the marketplace campaign wizard (emoji-picker-react v3, native emojis).
export const EmojiPickerButton: React.FC<EmojiPickerButtonProps> = ({
    onSelect,
    className,
    ariaLabel = 'Insert emoji',
    align = 'end'
}) => {
    const [open, setOpen] = useState(false);

    const handleEmojiClick = useCallback(
        (_event: React.MouseEvent, data: IEmojiData) => {
            onSelect(data.emoji);
            setOpen(false);
        },
        [onSelect]
    );

    return (
        <Dropdown
            open={open}
            onOpenChange={setOpen}
        >
            <DropdownTrigger>
                <button
                    type="button"
                    className={className}
                    aria-label={ariaLabel}
                >
                    <FontAwesomeIcon icon={faFaceSmile} />
                </button>
            </DropdownTrigger>
            <DropdownContent
                side="bottom"
                align={align}
                className={styles.popover}
            >
                <Picker
                    onEmojiClick={handleEmojiClick}
                    disableAutoFocus
                    skinTone={SKIN_TONE_LIGHT}
                    native
                    groupNames={{ smileys_people: 'PEOPLE' }}
                />
            </DropdownContent>
        </Dropdown>
    );
};

export default EmojiPickerButton;
